
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocationH as ObiLocationHElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-h.js';
 
 
 

 
 export const ObiLocationH = createComponent({
   react: React,
   tagName: 'obi-location-h',
   elementClass: ObiLocationHElement,
   events: {
     
   }
  });
 
 